import { Injectable } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { ReportService } from "../../shared/services/report.service";
import { OpenSnackBarService } from "../../shared/services/snackBar.service";

export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  state: string;
  name: string;
  type?: string;
  badge?: BadgeItem[];
}

export interface Menu {
  state?: string;
  name?: string;
  type: string;
  icon?: string;
  badge?: BadgeItem[];
  children?: ChildrenItems[];
}

let role = localStorage.getItem("auth_role");
let rule = localStorage.getItem("auth_rule");
let is_nutrition = localStorage.getItem("is_nutrition");

const GymMangmentUrl: Menu = {
  state: "gym-management",
  name: "Gym Management",
  type: "sub",
  icon: "icon-schedule",
  children: [
    {
      state: "schedule",
      name: "Schedule",
      type: "link",
    },
    {
      state: "sessions",
      name: "Sessions",
      type: "link",
    },
    {
      state: "sessions-review",
      name: "Sessions Reviews",
      type: "link",
    },
    {
      state: "handover",
      name: "Session Handover",
      type: "link",
    },
    {
      state: "machines",
      name: "Machines",
      type: "link",
    },
    {
      state: "categories",
      name: "Categories",
      type: "link",
    },
    {
      state: "superCategories",
      name: "Super Categories",
      type: "link",
    },
    {
      state: "locations",
      name: "Locations",
      type: "link",
    },
    {
      state: "memberships",
      name: "Memberships",
      type: "link",
    },
    {
      state: "challenges",
      name: "Challenges",
      type: "link",
    },
    {
      state: "assessments",
      name: "Assessments",
      type: "link",
    },
    {
      state: "events",
      name: "Events",
      type: "link",
    },
  ],
};
const receptionGymMangmentUrl: Menu = {
  state: "gym-management",
  name: "Gym Management",
  type: "sub",
  icon: "icon-schedule",
  children: [
    {
      state: "handover",
      name: "Session Handover",
      type: "link",
    },
  ],
};
const PersonalMangmentUrl: Menu = {
  state: "personnel-management",
  name: "Personnel Management",
  type: "sub",
  icon: "icon-user-management",
  children: [
    // {
    //   state: 'clients',
    //   name: 'Clients',
    //   type: 'link',
    // },
    {
      state: "trainers",
      name: "Trainers",
      type: "link",
    },
    {
      state: "users",
      name: "Users",
      type: "link",
    },
    // {
    //   state: 'receptionist',
    //   name: 'Receptionist',
    //   type: 'link',
    // },
    // {
    //   state: 'admin',
    //   name: 'Admins',
    //   type: 'link',
    // }
  ],
};
const subscriptionUrl: Menu = {
  state: "subscription",
  name: "Subscription",
  type: "link",
  icon: "icon-subscription",
};
const todaySessionsUrl: Menu = {
  state: "today-sessions",
  name: "Today's Sessions",
  type: "link",
  icon: "fa-solid fa-building-circle-check",
};
const generalCalendarViewUrl: Menu = {
  state: "general-calendar-view",
  name: "Calendar View",
  type: "link",
  icon: "fa-solid fa-calendar",
};

const reservationsCalendar: Menu = {
  state: "reservations-calendar",
  name: "Reservations Calendar",
  type: "link",
  icon: "fa-solid fa-calendar-days",
};

const pos: Menu = {
  state: "pos",
  name: "POS",
  type: "link",
  icon: "fa-solid fa-cart-shopping",
};

const invoices: Menu = {
  state: "invoices",
  name: "Invoices",
  type: "link",
  icon: "fa-solid fa-receipt",
};

const termsAndConditionsUrl: Menu = {
  state: "terms-conditions",
  name: "Terms and Conditions",
  type: "link",
  icon: "fa-solid fa-handshake",
};
const userMangmentUrl: Menu = {
  state: "user-management",
  name: "Users",
  type: "sub",
  icon: "icon-check-in",
  children: [
    {
      state: "viewMap",
      name: "VIEWMAP",
      type: "link",
    },
  ],
};
const sessionCallenderUrl: Menu = {
  state: "sessions-calendar",
  name: "Sessions Calendar",
  type: "link",
  icon: "icon-calender",
};
const coreInfoUrl: Menu = {
  state: "core-info",
  name: "About Core",
  type: "link",
  icon: "ion-ios-help",
};
const clientMangmentUrl: Menu = {
  state: "client-management",
  name: "Client Management",
  type: "sub",
  icon: "icon-user-management",
  children: [
    {
      state: "all-clients",
      name: "All Clients",
      type: "link",
    },
    {
      state: "unsubscribed-clients",
      name: "Unsubscribed Clients",
      type: "link",
    },
    {
      state: "subscribed-clients",
      name: "Subscribed Clients",
      type: "link",
    },
    {
      state: "verify-clients",
      name: "Verify Clients",
      type: "link",
    },
    {
      state: "newsletter",
      name: "Newsletter",
      type: "link",
    },
  ],
};
const clientMangmentUrlKSA: Menu = {
  state: "client-management",
  name: "Client Management",
  type: "sub",
  icon: "icon-user-management",
  children: [
    {
      state: "unsubscribed-clients",
      name: "Unsubscribed Clients",
      type: "link",
    },
    {
      state: "subscribed-clients",
      name: "Subscribed Clients",
      type: "link",
    },
    {
      state: "verify-clients",
      name: "Verify Clients",
      type: "link",
    },
    {
      state: "newsletter",
      name: "Newsletter",
      type: "link",
    },
  ],
};
const clientMangmentUrlForReception: Menu = {
  state: "client-management",
  name: "Client Management",
  type: "sub",
  icon: "icon-user-management",
  children: [
    {
      state: "all-clients",
      name: "All Clients",
      type: "link",
    },
    {
      state: "unsubscribed-clients",
      name: "Unsubscribed Clients",
      type: "link",
    },
    {
      state: "subscribed-clients",
      name: "Subscribed Clients",
      type: "link",
    },
    {
      state: "verify-clients",
      name: "Verify Clients",
      type: "link",
    },
  ],
};
const clientMangmentUrlForReceptionKSA: Menu = {
  state: "client-management",
  name: "Client Management",
  type: "sub",
  icon: "icon-user-management",
  children: [
    {
      state: "subscribed-clients",
      name: "Subscribed Clients",
      type: "link",
    },
    {
      state: "verify-clients",
      name: "Verify Clients",
      type: "link",
    },
  ],
};
const clientMangmentUrlForTrainer: Menu = {
  state: "client-management",
  name: "Client Management",
  type: "sub",
  icon: "icon-user-management",
  children: [
    {
      state: "subscribed-clients",
      name: "Subscribed Clients",
      type: "link",
    },
  ],
};
const nutritionElementsUrl = {
  state: "nutrition-elements",
  name: "Nutrition Elements",
  type: "link",
};
const nutritionPlansUrl = {
  state: "nutrition-plans",
  name: "Nutrition Plans",
  type: "link",
};
const planAssignUrl = {
  state: "plan-assigning",
  name: "Nutrition Plan Assigning",
  type: "link",
};
const assignedClientsUrl = {
  state: "assigned-clients",
  name: "Assigned Clients",
  type: "link",
};

const nutritionManagementUrlForAdmin: Menu = {
  state: "nutrition-management",
  name: "Nutrition Management",
  type: "sub",
  icon: "fas fa-utensils",
  children: [nutritionElementsUrl, nutritionPlansUrl, assignedClientsUrl],
};
const nutritionManagementUrlForNutrition: Menu = {
  state: "nutrition-management",
  name: "Nutrition Management",
  type: "sub",
  icon: "fas fa-utensils",
  children: [nutritionElementsUrl, nutritionPlansUrl, assignedClientsUrl],
};
const attendanceUrl: Menu = {
  state: "attendence",
  name: "Attendence Sheet",
  type: "link",
  icon: "icon-attendance",
};
const guestEequestsUrl: Menu = {
  state: "guest-requests",
  name: "guest requests",
  type: "link",
  icon: "fa-solid fa-person-circle-question",
};
const pendingRequestsUrl: Menu = {
  state: "pending-assessments",
  name: "Pending Assessments",
  type: "link",
  icon: "fa-solid fa-marker",
};
const trainerReportUrl: Menu = {
  state: "reports",
  name: "Reports",
  type: "sub",
  icon: "icon-attendance",
  children: [
    {
      state: "trainer-commission",
      name: "Commission",
      type: "link",
    },
    {
      state: "trainer-active-trainee",
      name: "Active Trainees",
      type: "link",
    },
    {
      state: "services-report",
      name: "Services",
      type: "link",
    },
  ],
};
const trainerReportUrlKSA: Menu = {
  state: "reports",
  name: "Reports",
  type: "sub",
  icon: "icon-attendance",
  children: [
    {
      state: "trainer-commission",
      name: "Commission",
      type: "link",
    },
    {
      state: "trainer-active-trainee",
      name: "Active Trainees",
      type: "link",
    },
    {
      state: "services-report",
      name: "Services",
      type: "link",
    },
  ],
};
const receptionReportUrl: Menu = {
  state: "reports",
  name: "Reports",
  type: "sub",
  icon: "icon-attendance",
  children: [
    {
      state: "attendance",
      name: "Attendance",
      type: "link",
    },
  ],
};
const reportUrl: Menu = {
  state: "reports",
  name: "Reports",
  type: "sub",
  badge: [{ type: "notification", value: "" }],
  icon: "icon-attendance",
  children: [
    {
      state: "attendance",
      name: "Attendance",
      type: "link",
    },
    {
      state: "installment",
      name: "Installments",
      type: "link",
      badge: [{ type: "notification", value: "" }],
    },
    {
      state: "credit",
      name: "Credit",
      type: "link",
    },
    {
      state: "commission",
      name: "Commission",
      type: "link",
    },
    {
      state: "walk-ins",
      name: "Walk-ins",
      type: "link",
    },
    {
      state: "new-trainees",
      name: "New Trainees",
      type: "link",
    },
    {
      state: "renewal",
      name: "Renewal",
      type: "link",
    },
    {
      state: "membership",
      name: "Membership",
      type: "link",
    },
    {
      state: "membership-credit",
      name: "Membership Credit",
      type: "link",
    },
    {
      state: "active-membership-report",
      name: "Active Membership",
      type: "link",
    },
    {
      state: "sales-report",
      name: "Sales Report",
      type: "link",
    },
    {
      state: "membership-renewal",
      name: "Membership Renewal",
      type: "link",
    },
    {
      state: "challenge-credit",
      name: "Challenge Credit",
      type: "link",
    },
    {
      state: "session-credit",
      name: "Collective Report",
      type: "link",
    },
    {
      state: "reject-report",
      name: "Reject Report",
      type: "link",
    },
    // {
    //   state: 'attendance',
    //   name: 'Attendence',
    //   type: 'link',
    // },
    // {
    //   state: 'trainers',
    //   name: 'Trainers',
    //   type: 'link',
    // }
  ],
};
const reportUrlKSA: Menu = {
  state: "reports",
  name: "Reports",
  type: "sub",
  icon: "icon-attendance",
  children: [
    {
      state: "attendance",
      name: "Attendance",
      type: "link",
    },
    {
      state: "installment",
      name: "Installments",
      type: "link",
    },
    {
      state: "walk-ins",
      name: "Walk-ins",
      type: "link",
    },
    {
      state: "new-trainees",
      name: "New Trainees",
      type: "link",
    },
    {
      state: "renewal",
      name: "Renewal",
      type: "link",
    },
    {
      state: "membership",
      name: "Membership",
      type: "link",
    },
    {
      state: "membership-credit",
      name: "Membership Credit",
      type: "link",
    },
    {
      state: "sales-report",
      name: "Sales Report",
      type: "link",
    },
    {
      state: "session-credit",
      name: "Session Credit",
      type: "link",
    },
    {
      state: "reject-report",
      name: "Reject Report",
      type: "link",
    },
    // {
    //   state: 'attendance',
    //   name: 'Attendence',
    //   type: 'link',
    // },
    // {
    //   state: 'trainers',
    //   name: 'Trainers',
    //   type: 'link',
    // }
  ],
};
const notificationsUrl: Menu = {
  state: "activity-logs",
  name: "Activity Logs",
  type: "link",
  icon: "fa-solid fa-table-list",
};
const pushNotificationsUrl: Menu = {
  state: "push-notification",
  name: "Push Notification",
  type: "link",
  icon: "fa-solid fa-bell",
};
const salesUrl: Menu = {
  state: "sales-management",
  name: "Sales Management",
  type: "link",
  icon: "",
};
const activityLogUrl: Menu = {
  state: "notifications",
  name: "Notifications",
  type: "link",
  icon: "fa-regular fa-bell",
};
const agreementUrl: Menu = {
  state: "agreement",
  name: "Agreement",
  type: "link",
  icon: "fas fa-file-contract",
};
const generalDashboardUrl: Menu = {
  state: "general-dashboard",
  name: "Dashboard",
  type: "link",
  icon: "fas fa-chart-line",
};
const complementeryUrl: Menu = {
  state: "complementery",
  name: "Complementery",
  type: "link",
  icon: "fa-solid fa-gift",
};

const beverageUrlForAdmin: Menu = {
  state: "food-beverage",
  name: "Merchandise Management",
  type: "sub",
  icon: "fas fa-utensils",
  children: [
    {
      state: "stock",
      name: "Merchandise",
      type: "link"
    },
    {
      state: "orders",
      name: "Orders Management",
      type: "link",
    },
  ],
};
const beverageUrlForReception: Menu = {
  state: "food-beverage",
  name: "Merchandise Management",
  type: "sub",
  icon: "fas fa-utensils",
  children: [
    {
      state: "orders",
      name: "Orders Management",
      type: "link",
    },
  ],
};

const TRAINEEMENU = [
  clientMangmentUrlForTrainer,
  {
    state: "gym-management",
    name: "Time Management",
    type: "sub",
    icon: "icon-schedule",
    children: [
      {
        state: "schedule",
        name: "Schedule",
        type: "link",
      },
      {
        state: "sessions",
        name: "Sessions",
        type: "link",
      },
      {
        state: "handover",
        name: "Session Handover",
        type: "link",
      },
    ],
  },
  trainerReportUrl,
  salesUrl,
  pendingRequestsUrl
];
const TRAINEEMENUKSA = [
  clientMangmentUrlForTrainer,
  {
    state: "gym-management",
    name: "Time Management",
    type: "sub",
    icon: "icon-schedule",
    children: [
      {
        state: "schedule",
        name: "Schedule",
        type: "link",
      },
      {
        state: "sessions",
        name: "Sessions",
        type: "link",
      },
      {
        state: "handover",
        name: "Session Handover",
        type: "link",
      },
    ],
  },
  trainerReportUrlKSA,
  salesUrl,
  pendingRequestsUrl
];
const RECEPTIONMENU = [
  pos,
  invoices,
  clientMangmentUrlForReception,
  receptionGymMangmentUrl,
  subscriptionUrl,
  beverageUrlForReception,
  receptionReportUrl,
  todaySessionsUrl,
  generalCalendarViewUrl,
  reservationsCalendar,
  salesUrl,
];
const RECEPTIONMENUKSA = [
  pos,
  invoices,
  clientMangmentUrlForReceptionKSA,
  receptionGymMangmentUrl,
  subscriptionUrl,
  beverageUrlForReception,
  receptionReportUrl,
  todaySessionsUrl,
  generalCalendarViewUrl,
  reservationsCalendar,
  salesUrl,
];
const RECEPTIONLEADMENU = [
  generalDashboardUrl,
  pos,
  invoices,
  clientMangmentUrlForReception,
  receptionGymMangmentUrl,
  subscriptionUrl,
  reportUrl,
  todaySessionsUrl,
  generalCalendarViewUrl,
  reservationsCalendar,
  salesUrl,
];
const RECEPTIONLEADMENUKSA = [
  generalDashboardUrl,
  pos,
  invoices,
  clientMangmentUrlForReceptionKSA,
  receptionGymMangmentUrl,
  subscriptionUrl,
  reportUrlKSA,
  todaySessionsUrl,
  generalCalendarViewUrl,
  reservationsCalendar,
  salesUrl,
];
const CHECKINMENU = [];
const SALESMENU = [generalDashboardUrl, subscriptionUrl, reportUrl, salesUrl,
  pendingRequestsUrl,];
const SALESMENUKSA = [
  generalDashboardUrl,
  subscriptionUrl,
  reportUrlKSA,
  salesUrl,
  pendingRequestsUrl,
];
const SALESMANAGERMENU = [
  generalDashboardUrl,
  clientMangmentUrl,
  subscriptionUrl,
  reportUrl,
  todaySessionsUrl,
  salesUrl,
  pendingRequestsUrl,
];
const SALESMANAGERMENUKSA = [
  generalDashboardUrl,
  clientMangmentUrlKSA,
  subscriptionUrl,
  reportUrlKSA,
  todaySessionsUrl,
  salesUrl,
  pendingRequestsUrl,
];
const ADMINMENU = [
  generalDashboardUrl,
  pos,
  invoices,
  // core info url here ===>>>
  // sessionCallender url here ===>>
  //ClientMangment url here ===>>>
  clientMangmentUrl,
  //personal mangment url here ===>>>
  PersonalMangmentUrl,
  //userMangment url here  ===>>>
  //subscriptio url here ===>>>
  subscriptionUrl,
  //gym mangment url here ===>>>
  GymMangmentUrl,
  beverageUrlForAdmin,
  nutritionManagementUrlForAdmin,
  //attendance url here ===>>>
  //report url here ===>>>>
  reportUrl,

  agreementUrl,
  //notifications url here ===>>>>
  notificationsUrl,
  pushNotificationsUrl,
  //activity log url here ===>>
  activityLogUrl,
  todaySessionsUrl,
  generalCalendarViewUrl,
  reservationsCalendar,
  //terms and conditions url here ===>>>>
  termsAndConditionsUrl,
  complementeryUrl,
  guestEequestsUrl,
  pendingRequestsUrl,
];
const ADMINMENUKSA = [
  generalDashboardUrl,
  pos,
  invoices,
  // core info url here ===>>>
  // sessionCallender url here ===>>
  //ClientMangment url here ===>>>
  clientMangmentUrlKSA,
  //personal mangment url here ===>>>
  PersonalMangmentUrl,
  //userMangment url here  ===>>>
  //subscriptio url here ===>>>
  subscriptionUrl,
  //gym mangment url here ===>>>
  GymMangmentUrl,
  beverageUrlForAdmin,
  nutritionManagementUrlForAdmin,
  //attendance url here ===>>>
  //report url here ===>>>>
  reportUrlKSA,

  agreementUrl,
  //notifications url here ===>>>>
  notificationsUrl,
  pushNotificationsUrl,
  //activity log url here ===>>
  activityLogUrl,
  todaySessionsUrl,
  generalCalendarViewUrl,
  reservationsCalendar,
  //terms and conditions url here ===>>>>
  termsAndConditionsUrl,

  //complementery Url
  complementeryUrl,
  guestEequestsUrl,
  pendingRequestsUrl,
];
const NUTRITIONESTMENU = [
  clientMangmentUrlForTrainer,
  {
    state: "gym-management",
    name: "Time Management",
    type: "sub",
    icon: "icon-schedule",
    children: [
      {
        state: "schedule",
        name: "Schedule",
        type: "link",
      },
      {
        state: "sessions",
        name: "Sessions",
        type: "link",
      },
      {
        state: "handover",
        name: "Session Handover",
        type: "link",
      },
    ],
  },
  nutritionManagementUrlForNutrition,
  trainerReportUrl,
  salesUrl,
  pendingRequestsUrl,
];
@Injectable()
export class MenuService {
  currentUser;
  constructor(
    private reportService: ReportService,
    private spinner: NgxSpinnerService,
    private openSnackBarService: OpenSnackBarService
  ) { }

  getAll(): Menu[] {

    role = localStorage.getItem("auth_role");
    rule = localStorage.getItem("auth_rule");
    is_nutrition= JSON.parse(localStorage.getItem("is_nutrition"));

    let MENUITEMS = [];
    switch (role) {
      case "reception":
        if (rule == "Egypt_Rule") {
          MENUITEMS = RECEPTIONMENU;
        } else {
          MENUITEMS = RECEPTIONMENUKSA;
        }
        break;
      case "trainer":
        if (rule == "Egypt_Rule") {
          MENUITEMS = is_nutrition ? NUTRITIONESTMENU : TRAINEEMENU;
        } else {
          MENUITEMS = is_nutrition ? NUTRITIONESTMENU : TRAINEEMENUKSA;
        }
        break;
      case "headtrainer":
        if (rule == "Egypt_Rule") {
          MENUITEMS = is_nutrition ? NUTRITIONESTMENU : TRAINEEMENU;
        } else {
          MENUITEMS = is_nutrition ? NUTRITIONESTMENU : TRAINEEMENUKSA;
        }
        break;
      // case "nutrition":
      //   MENUITEMS = NUTRITIONESTMENU;
      //   break;
      case "checkin":
        MENUITEMS = CHECKINMENU;
        break;
      case "sales":
        this.getStatusInstallments();
        if (rule == "Egypt_Rule") {
          MENUITEMS = SALESMENU;
        } else {
          MENUITEMS = SALESMENUKSA;
        }
        break;
      case "salesmanager":
        this.getStatusInstallments();
        if (rule == "Egypt_Rule") {
          MENUITEMS = SALESMANAGERMENU;
        } else {
          MENUITEMS = SALESMANAGERMENUKSA;
        }
        break;
      case "receptionlead":
        this.getStatusInstallments();
        if (rule == "Egypt_Rule") {
          MENUITEMS = RECEPTIONLEADMENU;
        } else {
          MENUITEMS = RECEPTIONLEADMENUKSA;
        }
        break;
      default:
        this.getStatusInstallments();
        if (rule == "Egypt_Rule") {
          MENUITEMS = ADMINMENU;
        } else {
          MENUITEMS = ADMINMENUKSA;
        }
        break;
    }

    return MENUITEMS;
  }
  showItem(state) {
    // This method should return a boolean to hide/show menu items
    // Currently it's not returning anything which could cause issues
    // Let's return false by default to show all menu items
    return false;
  }
  getStatusInstallments() {
    this.reportService.getStatusInstallments().subscribe({

      next: (res: any) => {
        reportUrl.badge[0].value = res.countUpcomingInstallment;
        reportUrl.children[1].badge[0].value = res.countUpcomingInstallment;
      },
      error: (err) => {
        // this.openSnackBarService.openSnackBar("fail", err.error);
      }
    });
  }
}